import { createAsyncThunk } from '@reduxjs/toolkit';
import { addOrUpdateCart, clearCart, fetchCart, removeFromCart, UpdateCart } from '../../utils/api/cartApi';

// Fetch cart
export const fetchCartThunk = createAsyncThunk('cart/fetchCart', async ({customerId, userId}) => {
    const response = await fetchCart(customerId, userId);
    return response.data;
});

// Add or update cart
export const addToCart = createAsyncThunk(
    'cart/addToCart',
    async ({ customerId, userId, kits = [], items = [], invoices = [], groupItems = [] }) => {
        const response = await addOrUpdateCart(customerId, userId, kits, items, invoices, groupItems);
        return response.data;
    }
);

// Remove from cart
export const removeFromCartThunk = createAsyncThunk(
    'cart/removeFromCart',
    async ({ customerId, userId, kits = [], items = [], invoices = [], groupItems = [] }) => {
        const response = await removeFromCart(customerId, userId, kits, items, invoices, groupItems);
        return response.data;
    }
);

// Update cart (can use addOrUpdateCart)
export const updateCart = createAsyncThunk(
  'cart/updateCart',
  async ({ customerId, userId, kits = [], items = [], invoices = [], groupItems = [], operationType }) => {
    const response = await UpdateCart(customerId, userId, kits, items, invoices, groupItems, operationType);
    return response.data;
  }
);

// Clear cart
export const clearCartThunk = createAsyncThunk(
    'cart/clearCart',
    async ({customerId, userId}) => {
        const response = await clearCart(customerId, userId);
        return response.data;
    }
);

